<div [ngClass]="{'app-prispevok-editable': !p.readonly, 'app-prispevok-large': display == 'large', 'app-prispevok-mobile': display == 'mobile'}" class="mb-4 rounded-5 app-prispevok">

<div class="d-flex flex-row justify-content-between">

  <div class="small text-black-50 mb-2"><b>{{p.autor ? p.autor : "Anonym"}}</b>, {{getCas(p.cas)|date: 'dd.MM.yyyy HH:mm:ss'}}, {{p.stav}}</div>

  <div *ngIf="!p.readonly">
    <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="setEditOn()">
        <mat-icon>edit</mat-icon>
        <span i18n>Upraviť</span>
      </button>
      <button mat-menu-item (click)="delete(p)">
        <mat-icon>delete_outline</mat-icon>
        <span i18n>Odstrániť</span>
      </button>
    </mat-menu>
  </div>

</div>

<div class="d-flex flex-row">
  <div><mat-icon>face_6</mat-icon></div>
  <div class="ms-1 vlastna-sirka orezanie-textu" #editableDiv
       [ngClass]="{'div-editable': isEditable}"
       [attr.contenteditable]="isEditable"
       [innerHTML]="p.text"
       (input)="onInputChange($event)">
  </div>
</div>

<div *ngIf="isEditable" class="mt-3 d-flex flex-row justify-content-center">
  <button mat-flat-button i18n color="primary" (click)="cancelEdit()">Zrušiť</button>
  <button mat-flat-button i18n color="primary" class="ms-3" (click)="update()">Potvrdiť</button>
</div>

  <section *ngIf="p.reakcie.length > 0">
    <div class="ms-5 mt-3">
      <div *ngFor="let r of p.reakcie" class="mb-3">
        <div class="small text-black-50 mb-2 fst-italic"><b>{{r.autor}}</b>, {{getCas(r.cas)|date: 'dd.MM.yyyy HH:mm:ss'}}</div>
        <div class="d-flex flex-row">
          <div><mat-icon>support_agent</mat-icon></div>
          <div class="small ms-1 fst-italic" [innerHTML]="r.text"></div>
        </div>
      </div>
    </div>
  </section>

</div>
